// extracted by mini-css-extract-plugin
export default {"panel":"AddressDetails_panel__ydKIY","leftPanel":"AddressDetails_leftPanel__PrO5J","rightPanel":"AddressDetails_rightPanel__fB9Zi"};